import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import LinkIcon from '@material-ui/icons/Link';
import { MarkdownContent, Link } from '@backstage/core-components';
import { isValidUrl } from '../../utils/components.esm.js';
import { RadarTimeline } from '../RadarTimeline/RadarTimeline.esm.js';

const RadarDescription = (props) => {
  function showDialogActions(url2, links2) {
    return isValidUrl(url2) || Boolean(links2 && links2.length > 0);
  }
  const { open, onClose, title, description, timeline, url, links } = props;
  return /* @__PURE__ */ React.createElement(
    Dialog,
    {
      "data-testid": "radar-description",
      open,
      onClose,
      maxWidth: "lg",
      fullWidth: true
    },
    /* @__PURE__ */ React.createElement(DialogTitle, { "data-testid": "radar-description-dialog-title" }, title),
    /* @__PURE__ */ React.createElement(DialogContent, { dividers: true }, /* @__PURE__ */ React.createElement(MarkdownContent, { content: description }), /* @__PURE__ */ React.createElement(RadarTimeline, { timeline })),
    showDialogActions(url, links) && /* @__PURE__ */ React.createElement(DialogActions, null, links?.map((link) => /* @__PURE__ */ React.createElement(
      Button,
      {
        component: Link,
        to: link.url,
        onClick: onClose,
        color: "primary",
        startIcon: /* @__PURE__ */ React.createElement(LinkIcon, null),
        key: link.url
      },
      link.title
    )), isValidUrl(url) && /* @__PURE__ */ React.createElement(
      Button,
      {
        component: Link,
        to: url,
        onClick: onClose,
        color: "primary",
        startIcon: /* @__PURE__ */ React.createElement(LinkIcon, null),
        key: url
      },
      "LEARN MORE"
    ))
  );
};

export { RadarDescription };
//# sourceMappingURL=RadarDescription.esm.js.map
